import { useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { FormWrapper } from "./FormWrapper";
import { DataDialog } from "./DataDialog";
import { schema, uiSchema, initialData } from "./formSchema";
import "./index.css";

export function App() {
  const [data, setData] = useState<Record<string, unknown>>(initialData);
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Box className="form-container">
      <Paper elevation={3} className="form-paper">
        <FormWrapper
          schema={schema}
          uischema={uiSchema}
          data={data}
          onChange={setData}
        />
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            onClick={() => setDialogOpen(true)}
            fullWidth
          >
            Absenden
          </Button>
        </Box>
      </Paper>
      <DataDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        data={data}
      />
    </Box>
  );
}

export default App;
